import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Copy, Check } from "lucide-react";

const CreateChatbot = () => {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  const snippet = `<!-- Load the chat widget -->
<script>
  window.chatWidgetConfig = {
    title: "Customer Support",
    theme: "green",
    position: "bottom-right",
    businessId: ${user?.business_id},
  };
</script>
<script src="https://widget.microagent.services/chat-loader.production.js"></script>`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2s
    } catch (err) {}
  };

  return (
    <div className="bg-[#1e293b] mt-6 border border-[#334155] rounded-lg p-6">
      <h1 className="text-lg font-semibold text-white">Create Chatbot</h1>

      <div className="bg-[#020617] mt-6 border border-[#334155] rounded-lg p-6 relative">
        {/* Copy Button */}
        <button
          onClick={handleCopy}
          className="absolute right-3 top-3 text-[#94a3b8] hover:text-white transition"
          title="Copy code"
        >
          {copied ? (
            <Check className="w-5 h-5 text-green-400" />
          ) : (
            <Copy className="w-5 h-5" />
          )}
        </button>

        {/* Code Snippet */}
        <pre className="text-sm text-[#5fbf04] whitespace-pre-wrap overflow-x-auto">
          <code>{snippet}</code>
        </pre>
      </div>
    </div>
  );
};

export default CreateChatbot;
